import { useEffect } from "react";
import { createRoot } from "react-dom/client";

export const MetaMetricRenderer = ({ metrics }) => {
  useEffect(() => {
    metrics.forEach((metric, index) => {
      const container = document.getElementById(`dynamic-metric-${index + 1}`);
      if (container) {
        const root = createRoot(container);
        root.render(
          <div className="my-10 p-6 rounded-lg border">
            <h3 className="text-3xl my-0">{metric.heading}</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {metric.values.map((item, idx) => (
                <div key={idx} className="flex flex-col items-center text-center ">
                  <p className="text-4xl font-bold border-b-2 border-[#f1aa4e]">{item.value}</p>
                  <p className="text-gray-600 my-0">{item.description}</p>
                </div>
              ))}
            </div>
          </div>,
        );
      }
    });
  }, [metrics]);

  return null;
};
